import axios, { AxiosInstance, AxiosRequestHeaders } from 'axios';

const { REACT_APP_BACKEND_URL } = process.env;

export default function getApiClient(): AxiosInstance {
    const headers: AxiosRequestHeaders = {};
    if (localStorage.token)
        headers.Authorization = `Bearer ${localStorage.token}`;
    const instance = axios.create({
        baseURL: REACT_APP_BACKEND_URL || '/api/v1/',
        responseType: 'json',
        headers,
    });
    instance.interceptors.response.use(
        response => {
            return response;
        },
        error => {
            if (error.response.status === 401) {
                localStorage.removeItem('token');
            }
            return Promise.reject(error);
        }
    );
    return instance;
}
